/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get } from 'lodash';

// Components
import RegistryEditor from 'shared/ui/components/editors/RegistryEditor.vue';
import UnsavedChanges from 'shared/ui/modals/UnsavedChanges.vue';

const __vue_script__ = {
    name: 'GenericPreferencesEditor',

    components: {
        RegistryEditor
    },

    props: {
        params: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            submitting: false,
            canChangeSettings: false,
            regPath: null,
            suppages: [],
            title: null
        };
    },

    created() {
        this.subpages = get(this.params, 'currentController.routeOptions.settings.entries', []);
        this.regPath = this.subpages[0];

        const title = get(this.params, 'currentController.title');
        this.title = this.$te(title) ? this.$t(title) : title;
    },

    methods: {
        menuLabel(page) {
            const tKey = `blueprint.submenus.${this.$utils.strings.toSnakeCase(page)}`;
            return this.$te(tKey) ? this.$t(tKey) : this.$utils.strings.humanize(page, true);
        },

        goTo(subpage, bypass = false) {
            if (this.$refs.subpageForm?.isFormDirty() && !bypass) {
                this.$modal.show(UnsavedChanges, {
                    action: () => this.goTo(subpage, true)
                }, { height: 'auto' });
                return;
            }

            this.regPath = subpage;
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.regPath
    ? _c("div", { staticClass: "generic-preferences-editor subpage" }, [
        _vm.title ? _c("h1", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "nav-list-wrapper" }, [
            _c("div", { staticClass: "repeated-item-list-container" }, [
              _c(
                "ul",
                { staticClass: "nav nav-list" },
                _vm._l(_vm.subpages, function (subpage) {
                  return _c(
                    "li",
                    {
                      key: subpage,
                      class: { active: [_vm.regPath].includes(subpage) },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "has-action",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.goTo(subpage)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.menuLabel(subpage)))]
                      ),
                    ]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "view-wrapper" },
            [
              _c("registry-editor", {
                ref: "subpageForm",
                attrs: { event: _vm.params.event, path: _vm.regPath },
              }),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/pages/GenericPreferencesEditor.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__